import type {TranslationKey} from "./ua";

const en: Record<TranslationKey, string> = {
    "common.loading": "Waiting for response...",

    "nav.login": "Log in",
    "nav.profile": "Profile",
    "nav.logout": "Log out",
    "nav.stats": "Statistics",
    "nav.topPlayers": "Top players",
    "nav.leaders": "Leaders",
    "nav.shop": "Shop",

    "header.donateInfo": "Donate 1000 UAH or more and get +10% to your top-up. These are voluntary donations for the project's development and are non-refundable.",
    "header.bonus": "Your personal bonus +{n}% 👍",
    "header.noBonus": "You don't have a personal bonus yet 😕",

    "servers.title": "Choose server type",
    "servers.text": "This affects which items are available for purchase, <b>trio</b> does not have all items.",

    "footer.agreement": "User agreement",
    "footer.privacy": "Privacy policy",
    "footer.about": "About us",

    "product.buy": "Buy",
    "product.loginSteam": "Log in with Steam",
    "product.friendPlaceholder": "Friend's SteamId",
    "product.noServer": "You haven't selected a server!",
    "product.noFriend": "You haven't entered your friend's steamId!",
    "product.badSteamId": "Invalid SteamID: it must be exactly 17 digits!",
    "product.error": "Something went wrong",
    "product.confirmBefore": "Are you sure you want to buy",
    "product.confirmOnServer": "on server",
    "product.pickup": "After purchase, pick it up with the <b>\"u\"</b> key",
    "product.yes": "Yes",
    "product.cancel": "Cancel",

    "stats.title": "Top players",
    "stats.subtitle": "The best players on our servers by kills, K/D and shot distance",
    "stats.kills": "Kills",
    "stats.killsLabel": "kills",
    "stats.kd": "K/D",
    "stats.distance": "Distance",
    "stats.distanceLabel": "longest shot",
    "stats.playtime": "Playtime",
    "stats.playtimeLabel": "played",
    "stats.deaths": "Deaths",
    "stats.farthest": "Farthest",
    "stats.time": "Time",
    "stats.player": "Player",
    "stats.error": "Statistics are temporarily unavailable. Please try again later.",
    "stats.empty": "No data yet.",
    "stats.hours": "h",
    "stats.minutes": "min",
    "stats.meters": "m",
};

export default en;
